import { createContext } from "react";

export const AuthContext = createContext({
  user: null,
  token: null,
  loginWithSSO: async () => {},
  logout: () => {},
  isAuthenticated: false,
  isAuthLoading: false,
  isAuthReady: false,
});
